<template>
  <credentials-layout title="">
    <div class="w-80 mx-auto my-24">
      <div
        class="
          mx-auto
          max-w-md
          px-6
          py-12
          border-0
          my-auto
        "
      >
      <div class="w-full p-4 -mt-12">
      <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 172 172"><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,172v-172h172v172z" fill="none"></path><g><g><g><path d="M112.18969,99.53828c-21.52682,-6.4553 -34.42003,-28.43309 -29.55131,-50.37325c4.86871,-21.94016 25.84805,-36.40133 48.08477,-33.14511c22.23672,3.25622 38.18891,23.12545 36.56251,45.54039c-1.6264,22.41494 -20.27976,39.77323 -42.75363,39.78532c-4.18024,0.0027 -8.33839,-0.6062 -12.34234,-1.80734zM144.70508,78.18945v-19.40039c0,-3.71066 -3.00809,-6.71875 -6.71875,-6.71875h-0.19484v-6.94719c0.00208,-3.45288 -1.36129,-6.7665 -3.79273,-9.21812c-2.40103,-2.45107 -5.68621,-3.83462 -9.11734,-3.83977c-3.4442,0.01857 -6.73988,1.40488 -9.16175,3.85384c-2.42187,2.44896 -3.77143,5.75986 -3.75169,9.20405v6.94719h-0.19148c-3.71066,0 -6.71875,3.00809 -6.71875,6.71875v19.40039c0.0013,3.71013 3.00862,6.71745 6.71875,6.71875h26.20984c3.71013,-0.0013 6.71745,-3.00862 6.71875,-6.71875z" fill="#fcf6eb"></path><path d="M158.47852,84.63945v58.26836c0.00261,1.53621 -0.25992,3.06135 -0.77602,4.50828l-0.0168,-0.00672l-47.60906,-46.21156l2.11305,-1.65953c17.02621,5.10568 35.43739,-0.82026 46.28883,-14.89883z" fill="#ff8303"></path><path d="M157.6857,147.40938l0.0168,0.00672c-1.90883,5.35349 -6.97787,8.92831 -12.66148,8.92922h-126.98102c-5.68493,-0.00002 -10.75495,-3.57688 -12.66148,-8.93258l0.00672,-0.00336l48.88227,-45.98984l17.59977,13.53828c6.07244,4.73611 14.58771,4.73611 20.66016,0l17.52922,-13.76z" fill="#fcf6eb"></path><path d="M124.63281,71.82008c0.06047,0.00336 0.11758,0.00336 0.17805,0.00336c1.69688,-0.01667 3.06587,-1.39293 3.07354,-3.08988c0.00767,-1.69695 -1.34881,-3.08553 -3.04547,-3.11754c-1.69666,-0.03201 -3.10456,1.30442 -3.16091,3.00044c-0.05635,1.69603 1.25975,3.12295 2.95479,3.20362zM144.70508,58.78906v19.40039c-0.0013,3.71013 -3.00862,6.71745 -6.71875,6.71875h-26.20984c-3.71013,-0.0013 -6.71745,-3.00862 -6.71875,-6.71875v-19.40039c0,-3.71066 3.00809,-6.71875 6.71875,-6.71875h26.20984c3.71066,0 6.71875,3.00809 6.71875,6.71875z" fill="#ff8303"></path><path d="M137.79148,51.71086v0.35945h-25.82352v-6.94719c-0.01974,-3.44419 1.32982,-6.75509 3.75169,-9.20405c2.42187,-2.44896 5.71755,-3.83527 9.16175,-3.85384c3.43113,0.00515 6.71631,1.3887 9.11734,3.83977c2.43145,2.45162 3.79482,5.76524 3.79273,9.21812z" fill="#fcf6eb"></path><path d="M54.2875,101.41953l-49.665,-38.20281v-3.15109c0,-7.42133 6.01617,-13.4375 13.4375,-13.4375h64.98039l0.28891,0.08398c-6.42204,22.53563 6.42721,46.05494 28.86039,52.82617l-2.11305,1.65953l-17.52922,13.76c-6.07244,4.73611 -14.58771,4.73611 -20.66016,0z" fill="#ffe9d1"></path><path d="M54.2875,101.41953l-48.88227,45.98984l-0.00672,0.00336c-0.51582,-1.44584 -0.77834,-2.96983 -0.77602,-4.50492v-79.69109z" fill="#ff8303"></path></g><g fill="#1b1a17"><path d="M124.53203,13.30313c-19.49534,0.02687 -36.78347,12.53292 -42.90997,31.04063h-63.56206c-4.17071,-0.00734 -8.17252,1.64714 -11.1204,4.59754c-2.94788,2.9504 -4.59894,6.95363 -4.58803,11.12433v82.84219c-0.01661,1.77923 0.27832,3.54763 0.87142,5.22517c2.23561,6.26954 8.18083,10.44868 14.83702,10.42952h126.98102c6.67288,0.02058 12.64098,-4.14859 14.91764,-10.42112c0.62082,-1.67557 0.94415,-3.44672 0.95541,-5.23357v-57.49402c5.74664,-7.79727 8.85003,-17.2275 8.85699,-26.91363c0,-24.92186 -20.31716,-45.19703 -45.23902,-45.19703zM18.06,49.04688h62.28281c-2.75739,12.82421 0.19907,26.21361 8.10013,36.68438c4.90566,6.46258 11.44599,11.50003 18.94687,14.59312l-16.28995,12.78309c-5.21095,4.08059 -12.53465,4.07574 -17.74019,-0.01176l-66.30499,-51.0373v-1.99278c-0.01237,-2.9238 1.14271,-5.73161 3.20891,-7.80033c2.06619,-2.06872 4.87259,-3.22722 7.7964,-3.21842zM115.02063,102.67896c3.14643,0.67695 6.35579,1.01827 9.57422,1.01823c11.82232,0.03978 23.18317,-4.5853 31.61609,-12.87111v51.7935zM7.05469,142.70625v-74.7125l43.69069,33.60584zM145.04102,153.85938h-126.98102c-4.13263,0.01974 -7.93048,-2.26947 -9.84297,-5.93299l46.225,-43.45587l16.00037,12.32487c6.91825,5.41457 16.636,5.4179 23.55795,0.00806l15.91302,-12.48915l44.98203,43.59427c-1.91096,3.67273 -5.7143,5.96946 -9.85439,5.9508zM156.61574,83.20433c-7.6312,10.00526 -19.4987,15.87066 -32.08203,15.85625c-3.94353,-0.03511 -7.86551,-0.58602 -11.6661,-1.6387v0c-8.16328,-2.6875 -15.50318,-7.63452 -20.66889,-14.47353c-5.31981,-7.02504 -8.18621,-15.60229 -8.15891,-24.41426c-0.02026,-12.6278 5.86214,-24.53948 15.90127,-32.19961c7.04785,-5.4235 15.69794,-8.35161 24.59096,-8.3242c22.35333,0.02425 40.46854,18.13857 40.49391,40.49189c0.02993,8.94156 -2.93037,17.63646 -8.4102,24.70216z"></path><path d="M140.08594,49.98011v-4.85698c0.02056,-4.06941 -1.57763,-7.98004 -4.44244,-10.87027c-2.85219,-2.90657 -6.75436,-4.5426 -10.82659,-4.53919c-8.47352,0.04661 -15.31436,6.93581 -15.30128,15.40945v4.85766c-3.95099,1.11261 -6.69021,4.70372 -6.71875,8.80828v19.40039c0,5.00144 3.97851,9.1543 8.97961,9.1543h26.20984c5.03979,-0.0384 9.1159,-4.11451 9.1543,-9.1543v-19.40039c-0.0406,-4.21119 -2.95412,-7.8492 -7.05469,-8.80895zM124.83102,34.4168c2.80317,0.00112 5.48706,1.13439 7.4427,3.1427c1.99854,2.00905 3.11695,4.72984 3.1091,7.56363v4.59563h-21.16406v-4.59563c-0.00939,-5.88017 4.73224,-10.66383 10.61227,-10.70633zM142.4375,78.27344c0,2.41193 -1.95526,4.36719 -4.36719,4.36719h-26.20312c-2.41193,0 -4.36719,-1.95526 -4.36719,-4.36719v-19.48437c0,-2.41193 1.95526,-4.36719 4.36719,-4.36719h26.20313c2.41193,0 4.36719,1.95526 4.36719,4.36719z"></path><path d="M124.81086,63.20664c-2.52744,-0.00299 -4.72907,1.72302 -5.32945,4.17811c-0.60038,2.45509 0.55625,5.00234 2.79984,6.16608v3.04292c0,1.29873 1.05283,2.35156 2.35156,2.35156c1.29873,0 2.35156,-1.05283 2.35156,-2.35156v-2.87025c2.38711,-1.03107 3.72177,-3.59698 3.19549,-6.14344c-0.52628,-2.54646 -2.76874,-4.37309 -5.36901,-4.37342zM124.81086,67.90977c0.33176,-0.00055 0.62741,0.20925 0.73643,0.52259c0.10902,0.31334 0.00744,0.66134 -0.25302,0.86684c-0.21479,-0.06336 -0.43752,-0.09571 -0.66146,-0.09608c-0.12779,0.00093 -0.2553,0.01216 -0.38129,0.03359c-0.22043,-0.22463 -0.28435,-0.55969 -0.1621,-0.84969c0.12224,-0.29001 0.40672,-0.4782 0.72144,-0.47726z"></path></g></g></g></g></svg>
      </div>
        <h2 class="font-bold mx-auto text-center text-xl md:text-2xl">Almost in!</h2>
        <p class="font-extralight text-center mx-auto md:text-lg px-4 md:px-0">Check your email! We've sent you a magic link you can use to securely login to your account and update your password.</p>
      </div>
    </div>
    <p class="text-center">Don’t have an account?</p>
    <p class="text-center">
      <n-button
        text
        type="primary"
        class="text-orange"
        @click="() => router.push('/join')"
      >
        Sign Up
      </n-button>
      instead
    </p>
  </credentials-layout>
</template>


<script>
import { NButton } from "naive-ui";
import { useRouter } from "vue-router";
import { mapActions, mapMutations } from "vuex";
import { isEmail, required } from "../helpers/validations";
import credentialsLayout from "../components/base/credentialsLayout.vue";

import {
  getAuth,
  sendPasswordResetEmail,
} from "firebase/auth";

export default {
  name: "Login",
  components: { NButton, credentialsLayout },
  data() {
    return {
      username: "",
      password: "",
      errors: {
        email: null,
        password: null,
      },
    };
  },
  setup() {
    const router = useRouter();
    return { router };
  },
  methods: {
    ...mapActions(["login_user", "get_user"]),
    ...mapMutations(["setToken", "fireToast"]),
    async resetPassword() {
      this.validateEmail();
      if (!this.errors.email) {
        const auth = getAuth();
        sendPasswordResetEmail(auth, this.username)
          .then(() => {
            // password reset email sent
            this.$router.push(`/reset-password/sent`);
          })
          .catch((error) => {
            const errorCode = error.code;
            this.fireToast({
              text: `error :( - ${errorCode}`,
              type: "error",
            });
          });
      }
    },
    validateEmail() {
      let missing = required(this.username);
      let notEmail = isEmail(this.username);
      this.errors.email = missing ? missing : notEmail ? notEmail : null;
    },
  },
};
</script>

<style scoped>
.-z-1 {
  z-index: -1;
}

.origin-0 {
  transform-origin: 0%;
}

input:focus ~ label,
input:not(:placeholder-shown) ~ label,
textarea:focus ~ label,
textarea:not(:placeholder-shown) ~ label,
select:focus ~ label,
select:not([value=""]):valid ~ label {
  /* @apply transform; scale-75; -translate-y-6; */
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  transform: translateX(var(--tw-translate-x)) translateY(var(--tw-translate-y))
    rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y))
    scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  --tw-scale-x: 0.75;
  --tw-scale-y: 0.75;
  --tw-translate-y: -1.9rem;
}

input:focus ~ label,
select:focus ~ label {
  /* @apply text-black; left-0; */
  --tw-text-opacity: 1;
  /* color: rgba(0, 0, 0, var(--tw-text-opacity)); */
  left: 0px;
  color: #ff8303;
}
input:focus {
  border-color: #ff8303;
}
</style>
